var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeOpenText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.342,
    height: 56.342,
    viewBox: "0 0 56.342 56.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "envelope-open-text",
    x: 0,
    y: 0,
    width: 56.342,
    height: 56.342,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#envelope-open-text)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "envelope-open-text-2",
    "data-name": "envelope-open-text",
    d: "M19.171,31.234A5.555,5.555,0,0,1,15.66,30.1L0,18.787V34.746A3.6,3.6,0,0,0,3.595,38.34H34.747a3.582,3.582,0,0,0,3.595-3.527V18.787L22.683,30.1A6.053,6.053,0,0,1,19.171,31.234ZM36.964,12.2c-.659-.524-1.288-1.011-2.217-1.715v-3.3a3.6,3.6,0,0,0-3.595-3.595h-5.8c-.234-.168-.44-.318-.683-.487C23.41,2.18,20.916-.03,19.171,0c-1.737-.028-4.239,2.181-5.5,3.108-.243.168-.449.318-.683.487h-5.8A3.6,3.6,0,0,0,3.595,7.188v3.3c-.926.7-1.554,1.189-2.218,1.713A3.576,3.576,0,0,0,0,15.036v.8l7.189,5.195V7.188H31.153V21.019l7.189-5.195v-.789A3.562,3.562,0,0,0,36.964,12.2ZM13.18,19.1H25.162a1.186,1.186,0,0,0,1.2-1.131,1.2,1.2,0,0,0-1.2-1.2H13.18a1.2,1.2,0,0,0-1.2,1.2A1.146,1.146,0,0,0,13.18,19.1Zm0-4.793H25.162a1.2,1.2,0,0,0,1.2-1.2,1.142,1.142,0,0,0-1.2-1.131H13.18a1.186,1.186,0,0,0-1.2,1.131A1.16,1.16,0,0,0,13.18,14.309Z",
    transform: "translate(9 6)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpenText);
export default __webpack_public_path__ + "static/media/envelope-open-text.8f9d299bbf544bd863460223e004df78.svg";
export { ForwardRef as ReactComponent };